export default "__VITE_ASSET__DgrdNz4t__"